module.exports = __webpack_public_path__ + "img/line-logo-big.591c0d4d.png";